import React from 'react'
import ReactDOM from 'react-dom'
import Cookies from 'js-cookie'
import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
// import { WebSocketLink } from 'apollo-link-ws'
import { HttpLink } from 'apollo-link-http'
import { ApolloProvider } from '@apollo/react-hooks'
import App from './App'
// import { split } from 'apollo-link'
// import { getMainDefinition } from 'apollo-utilities'

import './styling/fonts/AvenirLTStd-Medium.otf'
import './styling/ChatWindow.css'

// Set up our apollo-client to point at the server we created
// this can be local or a remote endpoint
// uri: 'http://staging.gql.internal.apps.ntehub.com/graphql'
// uri: 'http://localhost:8000/graphql'
const httpLink = new HttpLink({
	// uri: 'https://nbot-graphql.herokuapp.com/graphql',
	// uri: 'http://localhost:4000/graphql',
	uri: 'https://gbc-graphql.launch.camera:443/graphql',
	headers: {
		'client-name': 'nBot [web]',
		'client-version': '1.0.0',
		'x-token': Cookies.get('x-token') 
			? Cookies.get('x-token')
			: null
	},
})

/*
No longer using Apollo Websockets
const wsLink = new WebSocketLink({
	uri: `wss://nbot-graphql.herokuapp.com/graphql`,
	headers: {
		'client-name': 'nBot [web]',
		'client-version': '1.0.0',
		'x-token': Cookies.get('x-token') 
			? Cookies.get('x-token')
			: null
	},
	options: {
		reconnect: true
	}
})

const link = split(
	// split based on operation type
	({ query }) => {
	  const definition = getMainDefinition(query);
	  return (
			definition.kind === 'OperationDefinition' &&
			definition.operation === 'subscription'
	  );
	},
	wsLink,
	httpLink
)
*/

const cache = new InMemoryCache()
const client = new ApolloClient({
	cache,
	link: httpLink
})

ReactDOM.render(
	<div style={{ padding: 0, margin: 0, height: "100%" }}>
		<ApolloProvider client={client}>
			<App />
		</ApolloProvider>
	</div>,
	document.getElementById('root'),
);